"use strict";

var _classCallCheck = require("/home/rodrigo/repo/clinica-oral-prime-gatsby-landing/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/rodrigo/repo/clinica-oral-prime-gatsby-landing/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Theme = void 0;

var Utils_1 = require("../../../Utils");

var ThemeDefault_1 = require("./ThemeDefault");

var Theme = /*#__PURE__*/function () {
  function Theme() {
    _classCallCheck(this, Theme);

    this.name = "";
    this.default = new ThemeDefault_1.ThemeDefault();
  }

  _createClass(Theme, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }

      if (data.name !== undefined) {
        this.name = data.name;
      }

      this.default.load(data.default);

      if (data.options !== undefined) {
        this.options = Utils_1.deepExtend({}, data.options);
      }
    }
  }]);

  return Theme;
}();

exports.Theme = Theme;